import { Splide, SplideProps, SplideTrack } from "@splidejs/react-splide";
import classcat from "classcat";
import React from "react";

import { IconLeft, IconRight } from "@touchtech/web-baselayer-ui";

import css from "./AttributeCarousel.module.css";
import useManageAttributeCarousel from "./hooks/useManageAttributeCarousel";

export enum ArrowSize {
  XS = "xs",
  S = "s",
}

type Props = {
  content: React.ReactNode;
  additionalOptions?: Partial<SplideProps>;
  arrowsSize?: ArrowSize;
};

const AttributeCarousel = ({
  content,
  additionalOptions,
  arrowsSize = ArrowSize.S,
}: Props) => {
  const { splideRef, expandedSliderOptions } = useManageAttributeCarousel({
    additionalOptions,
  });

  return (
    <Splide hasTrack={false} ref={splideRef} {...expandedSliderOptions}>
      <SplideTrack>{content}</SplideTrack>
      <div className="splide__arrows">
        <div
          className={classcat([
            "splide__arrow splide__arrow--prev",
            css.leftArrow,
            css.arrow,
            {
              [css.smallSize]: arrowsSize === ArrowSize.S,
            },
          ])}
        >
          <div className={classcat([`text-body-${arrowsSize}`, css.iconLeft])}>
            <IconLeft />
          </div>
        </div>

        <div
          className={classcat([
            "splide__arrow splide__arrow--next",
            css.rightArrow,
            css.arrow,
            {
              [css.smallSize]: arrowsSize === ArrowSize.S,
            },
          ])}
        >
          <div className={classcat([`text-body-${arrowsSize}`, css.iconRight])}>
            <IconRight />
          </div>
        </div>
      </div>
    </Splide>
  );
};

export default AttributeCarousel;
